/* AOV 20 — keeps each personalisation line tied to its garment (snippets/runit-pz-child.liquid).
   Garment lines carry properties._pz, their single priced personalisation line carries _pz_for.
   After any cart change: a personalisation whose garment is gone is removed, and its quantity
   follows the garment's. Then the cart drawer (or the /cart page) is redrawn.
   The theme's own quantity / remove call on a personalised garment (/cart/change {line, quantity})
   is sent as one /cart/update covering the garment and its personalisation, so both leave (or
   change quantity) together instead of the personalisation lingering until the clean-up above.
   The sub-row's Remove button takes the personalisation off and keeps the plain garment.
   Known gap (2026-10-11): the clean-up runs ~350ms after a cart write,
   so a Checkout tap (or an express button on /cart) inside that window can reach checkout with an
   orphan personalisation line. The theme's own remove pairs both lines in one update, so this needs
   another tab or a third-party cart write; express buttons add no new path. A cart validation
   Function is the server-side fix if it ever shows up in orders. */
(function () {
  var busy = false, timer = null, known = null; // known: the last cart we saw (for line numbers)
  var realFetch = window.fetch.bind(window);
  // Garment properties written by snippets/runit-personalise.liquid; stripped when the personalisation goes.
  var PZ_KEYS = ['_pz', 'Personalisation', 'Instagram', 'Text', 'Number plate', 'Reflective print', 'Placement', 'Wanted stars'];
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  // {line|id, quantity, sections...} on a personalised garment -> one update for garment + personalisation.
  function pairedBody(body) {
    if (!known || typeof body !== 'string') return null;
    var b; try { b = JSON.parse(body); } catch (e) { return null; }
    var q = parseInt(b.quantity, 10);
    if (isNaN(q)) return null;
    var it = b.line ? known.items[parseInt(b.line, 10) - 1]
      : known.items.filter(function (i) { return i.key === b.id; })[0];
    var id = it && it.properties && it.properties._pz;
    if (!id) return null;
    var child = known.items.filter(function (i) { return i.properties && i.properties._pz_for === id; })[0];
    if (!child) return null;
    var updates = {}; updates[it.key] = q; updates[child.key] = q;
    return JSON.stringify({ updates: updates, sections: b.sections, sections_url: b.sections_url });
  }
  // Only a whole cart (change / update) refreshes `known`; anything else (add.js returns just the
  // added lines) forgets it until reconcile re-reads /cart.js, so a stale line number is never paired.
  function remember(r) {
    known = null;
    r.clone().json().then(function (c) { if (c && c.items && 'item_count' in c) known = c; }, function () {});
    return r;
  }
  var CART_WRITE = /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/;

  function reconcile() {
    if (busy) return;
    busy = true;
    realFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        known = cart;
        var parents = {}, updates = {}, n = 0;
        cart.items.forEach(function (it) {
          var id = it.properties && it.properties._pz;
          if (id) parents[id] = (parents[id] || 0) + it.quantity;
        });
        cart.items.forEach(function (it) {
          var f = it.properties && it.properties._pz_for;
          if (!f) return;
          // A personalisation added a moment ago is waiting for its garment: leave it.
          var pend = (window.RLPZ_PENDING || {})[f];
          if (!parents[f] && pend && Date.now() - pend < 20000) return;
          var want = parents[f] || 0;
          if (it.quantity !== want) { updates[it.key] = want; n++; }
        });
        if (!n) return null;
        return realFetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refresh);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function refresh() {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') { drawerItems.onCartUpdate(); return; }
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var drawer = document.getElementById('CartDrawer') ? document.querySelector('cart-drawer') : null;
    if (!drawer) return;
    realFetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('cart-drawer');
      if (next) drawer.innerHTML = next.innerHTML;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var paired = /\/cart\/change(\.js)?(\?|$)/.test(url) && init && pairedBody(init.body);
    var p = paired
      ? realFetch('/cart/update.js', Object.assign({}, init, { method: 'POST', headers: JSON_HEADERS, body: paired }))
          .then(function (r) { return r.ok ? r : realFetch(input, init); }) // stale line numbers: the plain call
      : realFetch(input, init);
    if (CART_WRITE.test(url)) p = p.then(remember);
    if (CART_WRITE.test(url)) {
      p.then(function () { clearTimeout(timer); timer = setTimeout(reconcile, 350); }, function () {});
    }
    return p;
  };
  // Remove personalisation, keep the garment. Shopify can't drop line properties in place (an empty
  // or blank set is ignored or kept as blank values), so both lines go in one update and the plain
  // garment is added back; if that add fails, the original pair is restored. One redraw at the end.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pz-remove]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var childKey = btn.getAttribute('data-pz-remove'), parentKey = btn.getAttribute('data-pz-parent');
    var post = function (url, body) { return realFetch(url, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) }); };
    busy = true;
    realFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var g = cart.items.filter(function (i) { return i.key === parentKey; })[0];
        var c = cart.items.filter(function (i) { return i.key === childKey; })[0];
        if (!g || !c) return null;
        var plain = {};
        Object.keys(g.properties || {}).forEach(function (k) { if (PZ_KEYS.indexOf(k) < 0) plain[k] = g.properties[k]; });
        var drop = {}; drop[g.key] = 0; drop[c.key] = 0;
        return post('/cart/update.js', { updates: drop })
          .then(function () { return post('/cart/add.js', { items: [{ id: g.variant_id, quantity: g.quantity, properties: plain }] }); })
          .then(function (r) {
            if (r.ok) return null;
            return post('/cart/add.js', { items: [
              { id: g.variant_id, quantity: g.quantity, properties: g.properties },
              { id: c.variant_id, quantity: c.quantity, properties: c.properties }
            ] });
          });
      })
      .catch(function () {})
      .then(function () { busy = false; known = null; refresh(); reconcile(); });
  });

  // Carts left inconsistent by another tab or an old session get fixed on load.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else reconcile();
})();
